import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=edcf8f20"
import script from "./HelpModal.vue?vue&type=script&lang=ts"
export * from "./HelpModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edcf8f20')) {
      api.createRecord('edcf8f20', component.options)
    } else {
      api.reload('edcf8f20', component.options)
    }
    module.hot.accept("./HelpModal.vue?vue&type=template&id=edcf8f20", function () {
      api.rerender('edcf8f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/HelpModal.vue"
export default component.exports